// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"0ef3c37d","135":"32db59b6","141":"78c1f6d2","342":"26ee8935","528":"55c4e9e7","859":"95f27a69"}[chunkId] + ".chunk.css";
};